import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { Checkbox, Grid, Switch } from '@material-ui/core';
import PublicPage from '../PublicPage';
import Typo from '../../components/CustomTypo';
import { portalCfg } from '../../../portal.router.config';
import Button from '../../components/ButtonCustom';
import { LinkRouter } from '../../components/Link';
import { Field, Form } from 'react-final-form';
import { TextFieldComponent, TextFieldWithSelectComponent, SelectComponent } from '../../components/FormElement';
import validators from '../../utils/validators';
import SocialComponent from '../../components/SocialComponent'
import { SwichGreenActiveIcon, SwichIcon } from '../../components/icons'
import countries from '../../../countries';
import { domainName, portal_config } from '../../../portal.config';
const lang_icon_en = portalCfg.publicPath + "/icons/usa_flag.png";

const styles = theme => ({
    container: {
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10),
        [theme.breakpoints.down('sm')]: {
            paddingBottom: theme.spacing(2),
        },
    },
    marginTop: {
        marginTop: theme.spacing(4),
    },
    marginTop4x: {
        marginTop: theme.spacing(8),
    },
    formLogin: {
        marginTop: theme.spacing(4),
        backgroundColor: theme.palette.background.box,//'#ffffff1f',
        borderRadius: 10,
        padding: theme.spacing(5, 15, 10, 15),
    },
    swichSmall: {
        marginTop: theme.spacing(2),
        width: 35,
        height: 20,
        resizeMode: 'contain',
        cursor: 'pointer'
    }
});
function RegisterView(props){
    const { classes, t, showAlert, onShowLoading, onReceiveMarketing, register_info, onSelectCountry, auth_support } = props;
    return (
        <PublicPage rightComponent={<RegisterViewComponent classes={classes} t={t}
            onSubmit={props.onSubmit}
            showAlert={showAlert}
            onShowLoading={onShowLoading}
            onReceiveMarketing={onReceiveMarketing}
            register_info={register_info}
            onSelectCountry={onSelectCountry}
            country_select={props.country_select}
            auth_support={auth_support}
            agreement_countries = {props.agreement_countries}
            country_agreement = {props.country_agreement} 
            country_default={props.country_default}
            accept_policy={props.accept_policy}
            onChangeCheckboxPolicy={props.onChangeCheckboxPolicy} />} />
    );
}
function RegisterViewComponent(props) {
    const { classes, t, showAlert, onShowLoading, onSelectCountry, auth_support, country_select } = props;
    return (
        <Grid xs={12} sm={12} md={12} item container>
            <Grid xs={12} sm={12} item container>
                <Typo variant='h2' color={domainName =='buyway' ? 'onPrimary' : 'primary'} mg_bottom_md>{t('btn_register')}</Typo>
            </Grid>
            <Grid xs={12} item container direction="row">
                <Typo variant='body2' color={domainName =='buyway' ? 'onPrimary' : 'primary'} center>{t('already_account')}&nbsp;</Typo>
                <LinkRouter to='login' variant='body2' size='sm' color='primary'>{t('btn_login')}</LinkRouter>
            </Grid>
            <Grid xs={12} sm={12} item container justify='center'>
                <RegisterForm classes={classes} t={t} 
                    onSubmit={props.onSubmit} 
                    register_info={props.register_info} 
                    onReceiveMarketing={props.onReceiveMarketing} 
                    onSelectCountry={onSelectCountry} 
                    country_select={country_select}
                    agreement_countries = {props.agreement_countries}
                    country_agreement = {props.country_agreement} 
                    country_default = {props.country_default} 
                    accept_policy={props.accept_policy}
                    onChangeCheckboxPolicy={props.onChangeCheckboxPolicy}/>
            </Grid>
            {(auth_support.facebook || auth_support.google) ? <SocialComponent showAlert={showAlert} onShowLoading={onShowLoading} auth_support={auth_support} /> : null}
        </Grid>
    )
}
function RegisterForm(props) {
    const { classes, t, country_default, country_agreement, onSelectCountry } = props;
    return (
        <Form
            onSubmit={props.onSubmit}
            render={({ handleSubmit, reset, submitting, pristine, values }) => (
                <Grid xs={12} container item className={classes.marginTop}>
                    <Field
                        name="first_name"
                        component={TextFieldComponent}
                        label={t('first_name')}
                        placeholder={t('enter_your_firstname')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.required)}
                    />
                    <Field
                        name="last_name"
                        component={TextFieldComponent}
                        label={t('last_name')}
                        placeholder={t('enter_your_lastname')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.required)}
                    />
                    {/* <Field
                        name="phone"
                        component={TextFieldComponent}
                        label={t('phone_number')}
                        isEdit={true}
                        color='primary'
                        validate={validators.composeValidators(validators.mustBeNumber)}
                        startPrefix={'+357'}
                    /> */}
                    <Field
                        name="phone"
                        component={TextFieldWithSelectComponent}
                        label={t('phone_number')}
                        isEdit={true}
                        color='default'
                        validate={validators.composeValidators(validators.mustBeNumber)}
                        autoFocus={true}
                        selectData={countries}
                        defaultValueSelect={props.country_select}
                        valueSelect={props.country_select}
                        onSelectedChange={(event)=>props.onSelectCountry('country_code', event)}
                    />
                    {portal_config[domainName].isRegisterCountry&&props.agreement_countries&&props.agreement_countries.length&&props.agreement_countries.length>1&&<Field
                        name="country"
                        component={SelectComponent}
                        label={t('country')}
                        selectData={props.agreement_countries}
                        defaultValueSelect={country_default?country_default:null}
                        valueSelect={props.register_info.country_agreement?props.register_info.country_agreement: country_default}
                        onSelectedChange={(event)=>onSelectCountry('country_agreement', event)}
                        color='default'
                        placeholder = {t('Select')}
                        //isEdit={mode==='add'?true:false}
                        isEdit={true}
                        />}
                    <Field
                        name="referral_code"
                        component={TextFieldComponent}
                        label={t('referral_code')}
                        placeholder={t('referral_code_placeholder')}
                        isEdit={true}
                        color='default'
                        autoFocus={true}
                    />
                    <Typo mg_top_sm color={domainName =='buyway' ? 'onPrimary' : 'primary'} variant='body1'>{t("receive_marketing_information")}</Typo>
                    <Grid container item xs={12} alignItems='center'>
                        <Typo mg_right_md mg_top_xs color={domainName =='buyway' ? 'onPrimary' : 'primary'} variant='body1'>{t("setting_email")}</Typo>
                        <Grid onClick={() => props.onReceiveMarketing('email_opt_out', !props.register_info.email_opt_out)}>
                            {props.register_info.email_opt_out ? <SwichGreenActiveIcon className={classes.swichSmall} /> : <SwichIcon className={classes.swichSmall} />}
                        </Grid>
                        <Typo mg_top_xs mg_right_md mg_left_lg color={domainName =='buyway' ? 'onPrimary' : 'primary'} variant='body1'>{t("setting_sms")}</Typo>
                        <Grid onClick={() => props.onReceiveMarketing('sms_opt_out', !props.register_info.sms_opt_out)}>
                            {props.register_info.sms_opt_out ? <SwichGreenActiveIcon className={classes.swichSmall} /> : <SwichIcon className={classes.swichSmall} />}
                        </Grid>
                    </Grid>

                    <Grid item xs={12} container direction='row'>
                        <Grid item xs={1} style={{marginLeft:-10, marginTop: 6}}>
                            <Checkbox
                                color='secondary'
                                checked={props.accept_policy}
                                onChange={props.onChangeCheckboxPolicy}/>
                        </Grid>    
                    <Grid item xs={11}>
                     <Typo color={domainName =='buyway' ? 'onPrimary' : 'error'} variant='body2' className={classes.marginTop}>{t("term_and_conditions_pre")}
                        <LinkRouter to='term-conditions' target="_blank" color='primary' size='sm' >{t('term_and_conditions_upper')}</LinkRouter>
                        {" "}{t('and')}{" "}
                        <LinkRouter to='privacy-policy' target="_blank" color='primary' size='sm'>{t('privacy_title')}</LinkRouter>
                    </Typo>
                    </Grid>
                    </Grid>
                    <Grid xs={12} item container justify='center' className={classes.marginTop4x}>
                        <Button color='primary' fullWidth onClick={handleSubmit} disabled={!props.accept_policy}>{t('btn_register')}</Button>
                    </Grid>
                </Grid>
            )} />

    )
}
export default withStyles(styles)(withTranslation()(RegisterView));